import React, { Component } from "react";
import { Link } from "react-router-dom";

import MainBannerShort from "../Element/MainBannerShort";
import { setPageMeta } from "../../utils/pageMeta";

class Impressum extends Component {
    componentDidMount() {
        setPageMeta({
            title: "Impressum – Rumours Media",
            description: "Impressum von Rumours Media, Sebastian Brückmann, Braderuper Weg 3, 25999 Kampen auf Sylt.",
            path: "/impressum",
        });
    }

    render() {
        return (
            <>
                <div className="page-content bg-white rubik">
                    <MainBannerShort />
                    <div className="content-block">
                        <div className="container m-t50 m-b50">
                            <h1>Impressum</h1>

                            <h4>Angaben gemäß § 5 DDG</h4>
                            <p>
                                Sebastian Brückmann<br></br>
                                Rumours Media<br></br>
                                Braderuper Weg 3<br></br>
                                25999 Kampen
                            </p>

                            <h4>Kontakt</h4>
                            <p>
                                Telefon: +49 (0) 174 211 0055<br></br>
                                E-Mail: <a href="mailto:info@rumours-media.de">info@rumours-media.de</a>
                            </p>

                            <h4>Umsatzsteuer-ID</h4>
                            <p>
                                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br></br>
                                DE357957094
                            </p>

                            <h4>Redaktionell verantwortlich (§ 18 Abs. 2 MStV)</h4>
                            <p>
                                Sebastian Brückmann<br></br>
                                Braderuper Weg 3<br></br>
                                25999 Kampen
                            </p>

                            <h4>EU-Streitschlichtung</h4>
                            <p>
                                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
                                    https://ec.europa.eu/consumers/odr/
                                </a>
                                .<br></br>
                                Unsere E-Mail-Adresse finden Sie oben im Impressum.
                            </p>

                            <h4>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h4>
                            <p>
                                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                            </p>

                            <h4>Haftung für Inhalte</h4>
                            <p>
                                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter
                                jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen
                                zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis
                                einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                            </p>

                            <h4>Haftung für Links</h4>
                            <p>
                                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die
                                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
                                überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
                                Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                            </p>

                            <h4>Urheberrecht</h4>
                            <p>
                                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung
                                außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht
                                kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als
                                solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir
                                derartige Inhalte umgehend entfernen.
                            </p>

                            <p>
                                Informationen zum Umgang mit Ihren personenbezogenen Daten finden Sie in unserer <Link to="/datenschutz">Datenschutzerklärung</Link>.
                            </p>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
export default Impressum;
